import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '@modules/users/services/user.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthAppGuard {
  constructor(
    private _auth: AuthService,
    private _userService: UserService,
    private _router: Router,
  ) {}

  canActivate(): Observable<boolean> | boolean {
    const token = this._auth.getToken();

    if (!token) {
      this._router.navigate(['admin/login']);
      return false;
    }

    return this._userService.checkToken(token).pipe(
      map(res => {
        if (res?.status === 'success' && res?.data) {
          const identity = res.data;

          // Validar roles autorizados aquí si quieres
          if ([1, 2, 4].includes(identity.rol)) {
            localStorage.setItem('identity', JSON.stringify(identity));

            if (this._auth.isAuthenticated()) {
              return true;
            }
          }
        }

        this._router.navigate(['admin/login']);
        return false;
      }),
      catchError(() => {
        this._router.navigate(['admin/login']);
        return of(false);
      }),
    );
  }
}
